<template>
    <div>
        <div class="vx-row mt-4 match-height" v-if="menu == 0">
            <div v-for="(item,key) in arregloTipos" :key="key" class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-base" v-if="item.cantidadTipo > 0 || item.general == 1">
                <vx-card class="text-center recurso" style="cursor: pointer; min-height: 220px;">
                    <div  @click="irSeleccion(item)">
                        <div>
                            <img class="mx-auto card-img-top" v-bind:src="$data_book+'archivos/tipos/'+item.imagen" style="min-height: 200px;max-height: 190px; overflow: hidden;">
                        </div>
                        <div class="flex justify-center">
                            <span class="card-titulo"> {{item.nombre}}</span>
                        </div>
                    </div>
                    <!-- <div class="flex justify-center" >
                        <p class="mt-1">
                            <vs-chip transparent color="#2288E3" class="card-cantidad"> {{ externo == 1 ? 'Disponibless' : 'Asignados' }}: {{ item.asignados }}</vs-chip>
                        </p>
                        <p class="mt-1" v-if="item.noAsignados > 0">
                            <vs-chip v-if="externo == 0" transparent color="#E06B38" class="card-cantidad">Sin Asignar: {{ item.noAsignados }}</vs-chip>
                        </p>
                    </div> -->
                </vx-card>
            </div>
        </div>
        <div v-if="menu == 1">
            <vs-button color="success" class="p-2 mt-1" type="flat" @click="menu = 0;getTipos()">← ir a Recursos</vs-button>
            <ListadoRecursosVue class="mt-4" :externo="externo" :ObjetoRecurso="ObjetoRecurso" :codigoCurso="codigoCurso" :userEstudiante="userEstudiante" :userDocente="userDocente"/>
        </div>
    </div>
</template>
<script>
import ListadoRecursosVue from '../recursos/ListadoRecursos.vue';
export default{
    data(){
        return{
            menu:0,
            arregloTipos:[],
            usuario:[],
            userDocente:false,
            userEstudiante:false,
        }
    },
    components:{
        ListadoRecursosVue,
    },
    created(){
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted(){
        let me = this;
        //user docente
        if (me.usuario.id_group == 6)   me.userDocente    = true;
        //user estudiante
        if (me.usuario.id_group == 4)   me.userEstudiante = true;
        me.getTipos()
    },
    props:{
        codigoCurso:{
            type:String,
            default:'',
        },
        externo:{
            type:String,
            default:"0"
        },
    },
    methods:{
        getTipos() {
            let me = this;
            me.$vs.loading();
            var url = ""
            if(me.externo == '1') url = this.$server_url + 'tipos?docente='+me.usuario.idusuario+'&idlibro='+localStorage.idlibro
            if(me.externo == '0') url = this.$server_url + 'tipos?codigoCurso='+me.codigoCurso+'&idlibro='+localStorage.idlibro
            this.$http.get(url)
                .then(function (res) {
                    let datos = res.data
                    if(datos.length > 0){
                        //externo
                        if(me.externo == '1'){
                            me.arregloTipos = datos.filter(p => p.estado == 1)
                        }
                        else{   
                            //cursos
                            me.arregloTipos = datos.filter(p => p.estado == 1 && p.general == 0 && p.nombre != 'Planificaciones')
                        }
                    }
                    me.$vs.loading.close()
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()

                })
        },
        irSeleccion(item) {
            let me           = this
            me.ObjetoRecurso = item
            me.menu          = 1
        },
    }
}
</script>
<style scoped>
.recurso{
  margin: 2px 3px;
}
.recurso:hover {
    background: rgb(238, 230, 229);
    box-shadow: rgba(0, 0, 0, 0.18) 0px 5px 25px -2px;
    color: red;
}
.card-titulo{
    font-size: 20px;
    font-weight: 600;
    font-family: Inter;
    transition: 0.1s ease;
}
.con-vs-chip:hover{

}
.letrascard {
    padding: 10px 0px 10px 0px;
    color: white;
    font-size: 17px;
    position: relative;
    -webkit-box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.52);
    -moz-box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.52);
    box-shadow: inset 0px 0px 29px 200px rgba(0, 0, 0, 0.52);
}
.btn_ver {
    font-size: 14px;
    padding: 5px 15px 5px 15px !important;
}
.imagencard {
    border-radius: 6px;
}
</style>